import React, { useState } from "react";

import { DropdownSaveNoticeDrawer } from "components/opportunities/saving/DropdownSaveNoticeDrawer";
import { EntityType } from "components/opportunities/saving/types";
import { DropdownMenuItem } from "components/ui/dropdown_menu";
import { EventNames, useTracking } from "lib/tracking";

const ENTITY_TYPE_NOTICE: EntityType = "notice";

type Props = { noticeGuid: string };

/**
 * Component allows users to save a notice to a list through the notice drop-down menu.
 */
export default function SaveNoticeToListButton({ noticeGuid }: Props) {
  const { logEvent } = useTracking();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerClosing, setIsDrawerClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsDrawerClosing(true);
    setTimeout(() => {
      setIsDrawerOpen(false);
      setIsDrawerClosing(false);
    }, 300); // timeout duration to match the drawer closing animation duration
  };

  const onClick = async (evt: React.MouseEvent) => {
    setIsDrawerOpen(true);
    logEvent(EventNames.saveDataClicked, { "Data type": ENTITY_TYPE_NOTICE.toUpperCase() });
    evt.preventDefault(); // Need to ensure menu doesn't close as otherwise the drawer will be unmounted
  };

  return (
    <>
      <DropdownMenuItem onClick={onClick} icon="plus">
        Add to list
      </DropdownMenuItem>
      {(isDrawerOpen || isDrawerClosing) && (
        <DropdownSaveNoticeDrawer
          noticeGuid={noticeGuid}
          isOpen={isDrawerOpen && !isDrawerClosing}
          onClose={handleDrawerClose}
        />
      )}
    </>
  );
}
